import { Header } from '@business/workflows/ComponentUI/Header';
import { ProfileSidebar } from '@business/workflows/ComponentUI/ProfileSidebar/ProfileSidebar';
import { FC, ReactNode } from 'react';

interface ProfileLayoutProps {
  children?: ReactNode;
}

export const ProfileLayout: FC<ProfileLayoutProps> = ({ children }) => {
  return (
    <div className="h-screen flex overflow-hidden bg-gray-50 relative">
      <ProfileSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <div className={`mx-auto px-3 sm:px-5 lg:px-7 py-5 max-w-7xl`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
